import { render, staticRenderFns } from "./PropertyList.vue?vue&type=template&id=7f533f70"
import script from "./PropertyList.vue?vue&type=script&lang=js"
export * from "./PropertyList.vue?vue&type=script&lang=js"
import style0 from "./PropertyList.vue?vue&type=style&index=0&id=7f533f70&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports